import { Loader2 } from 'lucide-react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

interface GerencialSavingDialogProps {
  open: boolean
  dirtyCount: number
}

/**
 * Blocking modal shown while the batch update is in flight. Cannot be
 * dismissed; closes only when the parent flips `open` to false (after success
 * or error).
 */
export function GerencialSavingDialog({ open, dirtyCount }: GerencialSavingDialogProps) {
  return (
    <Dialog open={open}>
      <DialogContent
        className="bg-brand-dark border-brand-dark-lighter max-w-md"
        onInteractOutside={e => e.preventDefault()}
        onEscapeKeyDown={e => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle className="text-white text-lg font-display">
            Salvando alterações
          </DialogTitle>
        </DialogHeader>

        <div className="flex flex-col items-center justify-center py-8 gap-4">
          <Loader2 className="w-10 h-10 text-brand-primary animate-spin" />
          <p className="text-sm text-white text-center">
            Salvando {dirtyCount} alteraç{dirtyCount === 1 ? 'ão' : 'ões'} e
            reprocessando DRE…
          </p>
          <p className="text-xs text-brand-gray text-center max-w-sm">
            Isso pode levar até 1 minuto. <strong>Não feche a aba.</strong>
          </p>

          {/* Indeterminate progress bar — width-animated so the user sees motion */}
          <div className="w-full h-1 bg-brand-dark-lighter rounded-full overflow-hidden">
            <div
              className="h-full bg-brand-primary rounded-full animate-[indeterminate_1.6s_ease-in-out_infinite]"
              style={{
                width: '40%',
                animation: 'gerencial-saving-bar 1.6s ease-in-out infinite',
              }}
            />
          </div>
          <style>{`
            @keyframes gerencial-saving-bar {
              0%   { transform: translateX(-110%); }
              50%  { transform: translateX(70%); }
              100% { transform: translateX(220%); }
            }
          `}</style>
        </div>
      </DialogContent>
    </Dialog>
  )
}
